import React from 'react';
import { getSlugFromHostname } from '../config/domainMap.ts';
import Home from '../pages/home/Home.tsx';
import Drdaniloblanco from '../pages/drdaniloblanco/drdaniloblanco.tsx';

/** Páginas carregadas quando o visitante acessa `/` em um domínio personalizado. */
const slugPages: Record<string, React.FC> = {
    drdaniloblanco: Drdaniloblanco,
};

/**
 * Em linksvibe.com.br/ → Home.
 * Em domínio mapeado (ex.: www.drdaniloblanco.com.br/) → cartão do cliente,
 * sem redirecionar a URL.
 */
const DomainRoot: React.FC = () => {
    const slug = getSlugFromHostname();
    if (slug) {
        const Page = slugPages[slug];
        if (Page) return <Page />;
    }
    return <Home />;
};

export default DomainRoot;
